import { render } from "./device-warning-content.vue?vue&type=template&id=7344e4e6&ts=true"
import script from "./device-warning-content.ts?vue&type=script&lang=ts&external"
export * from "./device-warning-content.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__